/**
 * Campaign statuses
 */
export enum CampaignStatusType {
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  BOUNCED = 'bounced',
}
